import {priceHelper} from '@helpers/config-master.mjs';
import {niceMoney} from '@helpers/common/number.mjs';
import {BotDetector} from '@components/widgets/BotDetector';

export const PriceLoader = ({children, product}) => {
  const showMsrpToBots = priceHelper.showMsrpToBots;

  if (!showMsrpToBots) {
    return children;
  } else {
    const msrp = priceHelper.getMsrpPrice(product);

    const JustMsrpPrice = () => {
      return (
        <div className="flex justify-end md:justify-start">
          <div className="text-black text-lg font-normal">
            <span>{niceMoney(msrp)}</span>
          </div>
        </div>
      );
    };

    return <BotDetector botContent={<JustMsrpPrice />} userContent={children} />;
  }
};
